import { useState } from "react";
import axios from "axios";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { toast } from "sonner";
import { BookOpen, Download, Lock } from "lucide-react";
import { API } from "../../apiConfig";

export const LookbookManager = ({ token }) => {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const res = await axios.get(`${API}/lookbook`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Art-By-Arawol-Lookbook.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Lookbook downloaded");
    } catch (e) {
      toast.error("Failed to download lookbook");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Card data-testid="lookbook-manager">
      <CardHeader>
        <div className="flex items-center justify-between flex-wrap gap-3">
          <CardTitle className="flex items-center gap-2 text-lg">
            <BookOpen className="h-5 w-5 text-primary" strokeWidth={1.5} />
            The Lookbook
            <Badge variant="outline" className="ml-2 text-[10px] gap-1">
              <Lock className="h-3 w-3" /> Private — public download disabled
            </Badge>
          </CardTitle>
          <Button
            variant="outline"
            size="sm"
            className="rounded-full"
            onClick={handleDownload}
            disabled={downloading}
            data-testid="admin-lookbook-download-btn"
          >
            <Download className="h-4 w-4 mr-2" strokeWidth={1.5} />
            {downloading ? "Preparing..." : "Download PDF"}
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          The magazine-style PDF catalogue regenerates automatically when artworks change.
          Download it here and attach it to your own emails when sharing with collectors,
          designers or trade clients.
        </p>
      </CardContent>
    </Card>
  );
};

export default LookbookManager;
